var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.loaded)?_c('div',{staticClass:"loaderIcon"}):_c('div',[_c('IntroSection',{attrs:{"imageUrl":_vm.introImageUrl,"titlePrefix":_vm.titlePrefix,"title":_vm.title,"body":_vm.body}}),_c('vue-picture-swipe',{staticClass:"gallery",attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }